__turbopack_context__.v({
  "cell": "linkTable-module-scss-module__1tQqPW__cell",
  "emptyMessage": "linkTable-module-scss-module__1tQqPW__emptyMessage",
  "headerTitle": "linkTable-module-scss-module__1tQqPW__headerTitle",
  "paginatorContainer": "linkTable-module-scss-module__1tQqPW__paginatorContainer",
  "row": "linkTable-module-scss-module__1tQqPW__row",
  "stripe": "linkTable-module-scss-module__1tQqPW__stripe",
  "tableHeader": "linkTable-module-scss-module__1tQqPW__tableHeader",
  "tableHeaderCell": "linkTable-module-scss-module__1tQqPW__tableHeaderCell",
  "tableHeadersContainer": "linkTable-module-scss-module__1tQqPW__tableHeadersContainer",
  "tableWithPaginatorContainer": "linkTable-module-scss-module__1tQqPW__tableWithPaginatorContainer",
});
